var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.301,
    y: 0.448,
    width: 21.3,
    height: 31.185,
    rx: 1.625,
    transform: "rotate(12.694 7.301 .448)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.614,
    y: 2.407,
    width: 21.3,
    height: 31.185,
    rx: 1.625,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.823 21.041H8.273c-.283 0-.471.189-.471.472s.188.471.47.471h11.504c.282 0 .471-.188.471-.471s-.189-.472-.424-.472zM19.823 23.634H8.273c-.283 0-.471.189-.471.472s.188.471.47.471h11.504c.282 0 .471-.188.471-.471s-.189-.472-.424-.472zM19.823 26.227H8.273c-.283 0-.471.189-.471.471 0 .283.188.472.47.472h11.504c.282 0 .471-.189.471-.472 0-.282-.189-.47-.424-.47zM13.677 28.645H8.032c-.138 0-.23.152-.23.38s.092.38.23.38h5.622c.138 0 .23-.152.23-.38s-.092-.38-.207-.38zM19.448 9.789h-2.352V7.438a.6.6 0 0 0-.594-.595h-3.838a.6.6 0 0 0-.594.595v2.35H9.719a.6.6 0 0 0-.595.595v3.838a.6.6 0 0 0 .595.594h2.35v2.351a.6.6 0 0 0 .595.595h3.838a.6.6 0 0 0 .594-.595v-2.35h2.352a.6.6 0 0 0 .594-.595v-3.838a.583.583 0 0 0-.594-.594zm-.568 3.837h-2.351a.6.6 0 0 0-.595.595v2.351H13.26v-2.351a.6.6 0 0 0-.595-.595h-2.35v-2.675h2.35a.6.6 0 0 0 .595-.595v-2.35h2.675v2.35a.6.6 0 0 0 .595.595h2.351v2.675z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 13.626h-2.35a.6.6 0 0 0-.596.595v2.351H13.26v-2.351a.6.6 0 0 0-.594-.595h-2.351v-2.675h2.35a.6.6 0 0 0 .595-.595v-2.35h2.675v2.35a.6.6 0 0 0 .595.595h2.351v2.675z",
    fill: "#FDCF85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.3cbcae8c7bdb255b47f8491fd829a967.svg";
export { ForwardRef as ReactComponent };